import { AxiosResponse } from "axios";
import { AxiosInstance } from "./axiosInstance";
import {
  FirmwareUpgradeDto,
  FirmwareUpgradeDtoResponse,
  FirmwareVersionInfoRequest,
  FirmwareVersionInfoResponse,
} from "./interfaces/managerInterface.interface";
import { CommonResponse } from "./interfaces/commonInterface.interface";

const BASE_PATH = "/setting";
const API_PATH = `${BASE_PATH}/firmwareUpgradeConfig`;


export const getFirmwareUpgrade = async (
  accountId: string
): Promise<FirmwareUpgradeDtoResponse> => {
  try {
    const { data }: AxiosResponse<FirmwareUpgradeDtoResponse> =
      await AxiosInstance.get(`${API_PATH}/${accountId}`);
    return data;
  } catch (e) {
    throw e;
  }
};
export const postCreateFirmwareUpgrade = async ({
  accountId,
  payload,
}: {
  accountId: string;
  payload: FirmwareUpgradeDto;
}): Promise<FirmwareUpgradeDtoResponse> => {
  try {
    const { data }: AxiosResponse<FirmwareUpgradeDtoResponse> =
      await AxiosInstance.post(`${API_PATH}/create/${accountId}`, payload);
    return data;
  } catch (e) {
    console.error(e);
    throw new Error();
  }
};
export const postFirmwareVersionInfo = async (
  payload: FirmwareVersionInfoRequest
): Promise<FirmwareVersionInfoResponse> => {
  try {
    const { data }: AxiosResponse<FirmwareVersionInfoResponse> =
      await AxiosInstance.post(`${BASE_PATH}/featureSupport`, payload);
    return data;
  } catch (e) {
    throw e;
  }
};
export const putUpdateFirmwareUpgrade = async ({
  accountId,
  payload,
}: {
  accountId: string;
  payload: FirmwareUpgradeDto;
}): Promise<FirmwareUpgradeDtoResponse> => {
  try {
    const { data }: AxiosResponse<FirmwareUpgradeDtoResponse> =
      await AxiosInstance.put(`${API_PATH}/update/${accountId}`, payload);
    return data;
  } catch (e) {
    throw e;
  }
};
export const deleteFirmwareUpgrade = async (
  accountId: string
): Promise<CommonResponse> => {
  try {
    const { data }: AxiosResponse<CommonResponse> = await AxiosInstance.delete(
      `${API_PATH}/delete/${accountId}`
    );
    return data;
  } catch (e) {
    throw e;
  }
};
